import {
    Box,
    Heading, HStack, Spacer,
    Stack,
    StackDivider,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr
} from '@chakra-ui/react';
import React from 'react';
import RegistrationStateBadge from "./RegistrationStateBadge";
import {Census, RegistrationStateText, RequestTypeText} from "../../model/census";
import RequestStateBadge from "./RequestStateBadge";
import {CensusComment} from "../../model/censusComment";
import {commentTranslateKey} from "../../utils/commentTranslateKey";
import {censusTranslateKey} from "../../utils/censusTranslateKey";
import {assignmentTranslateKey, summaryAssignmentTranslateKey} from "../../utils/AssignmentTranslateKey";

interface SendCensusRenderProps {
    census: Census;
    asTable?: boolean;
    comments?: CensusComment[];
}

const CensusRenderComponent: React.FC<SendCensusRenderProps> = ({census, asTable = false, comments }) => {
    var filterTable = ['RegistrantId', 'YPSCitizenship', 'YPSResidence', 'YPSAccept', 'YPSKRKSent', 'VerifierId', 'AcceptorId', 'AssignmentsDTO'];
    return (
        <Box
            minWidth="55%"
            maxWidth="100%"
        >
            <TableContainer p="34" width="100%">
                <Heading p="5" as="h3" size="md" textAlign="start">Twój wniosek o rejestrację</Heading>
                    {asTable ?
                        <Table size='md' width="100%">
                            <Thead>
                                <Tr>
                                    <Th>ID</Th>
                                    <Th>Złożony wniosek</Th>
                                    <Th>Status</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                <Tr>
                                    <Td fontSize="sm" fontStyle="italic">{census.Id}</Td>
                                    <Td><RequestStateBadge requestState={RequestTypeText[census.Request]} /></Td>
                                    <Td align='right'><RegistrationStateBadge registrationState={RegistrationStateText[census.RegistrationState]} /></Td>
                                </Tr>
                            </Tbody>
                        </Table> :
                        <>
                            <Table size='md' width="100%">
                                <Tbody>
                                {Object.entries(census)
                                    .filter(([key, ]) => !filterTable.includes(key))
                                    .filter(([key, value]) => value !== "" && value !== null)
                                    .map(([key, value]) => (
                                    <tr key={key}>
                                        <th style={{
                                            paddingRight: '1.5rem',
                                            textAlign: 'left',
                                            wordWrap: 'break-word',
                                            wordBreak: 'break-word',
                                        }}>{censusTranslateKey[key] ? censusTranslateKey[key] : key}</th>
                                        <td style={{
                                            wordWrap: 'break-word',
                                            wordBreak: 'break-word',
                                            whiteSpace: 'normal',
                                            textAlign: 'left',
                                        }}>
                                            {
                                                (key === 'RegistrationState') ? <RegistrationStateBadge registrationState={RegistrationStateText[census.RegistrationState]} /> :
                                                (key === "Request") ? <RequestStateBadge requestState={RequestTypeText[census.Request]} /> : 
                                                (key === "KRKIssueDate" || key === "CreateDate") ? value.split('T')[0] :
                                                value
                                            }
                                        </td>
                                    </tr>
                                ))}
                                </Tbody>
                            </Table>
                            <Table size='md' width="100%" marginTop="10px">
                                <Tbody>
                                    {Object.entries(census.AssignmentsDTO).map(([assignmentKey, assignmentValue]) => (
                                        <>
                                            {Object.entries(assignmentValue)
                                                .filter(([key, value]) => key !== 'unit')
                                                .filter(([key, value]) => value !== "" && value !== null)
                                                .map(([key, value]) => (
                                                    <>
                                                    {key === "IsMain" ?
                                                        <Heading p="5" as="h5" size="md" textAlign="start">
                                                            {value ? "Główny przydział służbowy" : "Przydział służbowy"}
                                                        </Heading> :
                                                        <tr key={key}>
                                                            <th style={{
                                                                paddingRight: '1.5rem',
                                                                textAlign: 'left',
                                                                wordWrap: 'break-word',
                                                                wordBreak: 'break-word',
                                                            }}>{assignmentTranslateKey[key] ? assignmentTranslateKey[key] : key}</th>
                                                            <td style={{
                                                                wordWrap: 'break-word',
                                                                wordBreak: 'break-word',
                                                                whiteSpace: 'normal',
                                                                textAlign: 'left',
                                                            }}>
                                                                {typeof value === "string" && (key === "FunctionStartDate" || key === "FunctionEndDate") ? 
                                                                    value.split("T")[0] : 
                                                                    typeof value === "object" ? 
                                                                        JSON.stringify(value, null, 2) : 
                                                                        value}
                                                            </td>
                                                        </tr>}
                                                    </>))}
                                        </>
                                    ))}
                                </Tbody>
                            </Table>
                            {comments ? <>
                                <Heading p="5" as="h3" size="md" textAlign="start">Komentarze</Heading>
                                <Table size='md' width="100%">
                                <Tbody>
                                {Object.entries(comments)
                                    .map(([key, value]) => Object.entries(value)
                                    .filter(([key, ]) => !['Id', 'CensusId', 'CommenterId'].includes(key))
                                    .filter(([key, value]) => value !== "" && value !== null)
                                    .map(([key, value]) => (
                                    <tr key={key}>
                                        <th style={{
                                            paddingRight: '1.5rem',
                                            textAlign: 'left',
                                            wordWrap: 'break-word',
                                            wordBreak: 'break-word',
                                        }}>{commentTranslateKey[key] ? commentTranslateKey[key] : key}</th>
                                            <td style={{
                                                wordWrap: 'break-word',
                                                wordBreak: 'break-word',
                                                whiteSpace: 'normal',
                                                textAlign: 'left',
                                                    }}>
                                                        {
                                                            (key === 'RegistrationState') ? <RegistrationStateBadge registrationState={RegistrationStateText[census.RegistrationState]} /> :
                                                                (key === "CreateDate" || key === "ReadDate") ? value.split('T')[0] :
                                                                        value
                                                        }
                                            </td>
                                    </tr>
                                    )))}
                                    </Tbody>
                                </Table>
                            </> : <></>}
                        </>}
            </TableContainer>
        </Box>
    );
};

export default CensusRenderComponent;